import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Form, Accordion, Card, Button, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// Own constants/actions/components
import { items } from 'services/selectors/shopping-cart';
import { addItemsShoppingCartAction, deleteItemToShoopingCartById } from 'services/actions/shopping-cart';
import { resetExclusivitiesAction } from 'services/actions/exclusivity-experience-remove.js';
import ModalExclusivity from 'components/modal-exclusivity-experience';
import ModalCheck from 'components/modal-check';
import { setId } from 'helpers/random-id';
import { scrollEventMobile } from 'helpers/scroll-event';
import { hasExclusiveConflict } from 'helpers/exclusivity';

const TypeTravelMobile = (props) => {
  const { details, points, open, handleOpenExp, cards } = props;
  const {
    id,
    title,
    image,
    type,
    startDelivery,
    endDelivery,
    numberOfPeople,
    location,
    duration,
    stock,
    exclusivity,
  } = details;
  const stockValidation = stock !== null ? stock : 99;
  const [count, setCount] = useState('');
  const [isCheckedYouMustKnow, setIsCheckedYouMustKnow] = useState(false);
  const { id: pathId, pathName } = useParams();
  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors }, setFocus, clearErrors } = useForm({ mode: 'onChange' });
  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const itemsCart = useSelector(items);
  const sessionActive = Cookies.get('frontSession') !== undefined;
  const [dataItemActual, setDataItemActual] = useState([]);

  const onSubmit = (dataform) => {
    for (let i = 0; i < dataform.count; i += 1) {
      /* eslint-disable */
      const newObjSend = Object.assign({}, dataform, {
        id: setId(),
        experienceId: id,
        title: title,
        image: image,
        delivery: moment(dataform.endDelivery).format('DD/MM/YYYY'),
        startDelivery: moment(dataform.startDelivery).format('DD/MM/YYYY'),
        endDelivery: moment(dataform.endDelivery).format('DD/MM/YYYY'),
        type: type.constant,
        typeName: type.name,
        points: points,
        isGift: false,
        useCrisData: false,
        notes: "",
        membersList: [],
        location: location,
        duration: duration,
        numberOfPeople: numberOfPeople,
        exclusivity: exclusivity,
        stock: stock,
        youShouldKnowCheck: true,
      });
      setDataItemActual([newObjSend]);
      dispatch(addItemsShoppingCartAction(newObjSend));
    }
    handleOpen();
  };

  const handelClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
    handleOpenExp(!open);
  };

  const handlePlus = () => {
    setFocus('count');
    if (count < stockValidation) {
      setCount(Number(count) + 1);
      clearErrors(['count']);
    }
  };

  const handleLess = () => {
    setFocus('count');
    if (count > 0) {
      setCount(Number(count) - 1);
    }
    if( count-1 <= stockValidation ) {
      clearErrors(['count']);
    }
  };

  const removeAutoExclusivity = (indexExpRemove) => {
    dispatch(deleteItemToShoopingCartById(indexExpRemove));
    dispatch(resetExclusivitiesAction());
  };

  const modalShowCases = () => {
    if (hasExclusiveConflict(dataItemActual, cards)) {
      return (
        <ModalExclusivity
          stateInitial={show}
          close={handleClose}
          itemsCart={dataItemActual}
          removeFunc={removeAutoExclusivity}
          path="mis-experiencias" />
      );
    }

    return (
      <ModalCheck
        stateInitial={show}
        close={handleClose}
        itemsCart={dataItemActual}
        path="mis-experiencias" />
    );
  };

  useEffect(() => {
    scrollEventMobile();
  }, []);

  return (
    <div className="sticky-resumen-mobile d-lg-none d-xl-none">
      { itemsCart.length > 0
        && dataItemActual
        && dataItemActual.length > 0
        && sessionActive
        ? modalShowCases() : (
          <ModalCheck
            stateInitial={show}
            close={handleClose}
            itemsCart={dataItemActual}
            path="mis-experiencias" />
        ) }
      <Accordion className="ticket-mobile">
        <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="0"
              className={`text-left not-link ${open ? 'open' : ''}`}
              onClick={handelClick}>
              <h2 className="text-tangaroa title-header mb-0">{`${(Number(points)).toLocaleString('es-MX')} Puntos Aeroméxico Rewards`}</h2>
              <h4 className="py-15 subtitle-header">Tu Experiencia Aeroméxico Rewards</h4>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0" in={open}>
            <Card.Body>
              <div className="bg-westar p-15">
                {/* eslint-disable react/jsx-props-no-spreading */}
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <input {...register('id')} name="id-exp" value={id} hidden type="text" />
                  <input {...register('title')} name="title" value={title} hidden type="text" />
                  <input {...register('image')} name="image" value={image} hidden type="text" />
                  <input {...register('type')} name="type" value={type} hidden type="text" />
                  <input {...register('points')} name="points" value={points} hidden type="text" />
                  <input {...register('isGift')} name="isGift" value="false" hidden type="text" />
                  <input {...register('useCrisData')} name="useCrisData" value={false} hidden type="text" />
                  <input {...register('notes')} name="notes" value={null} hidden type="text" />
                  <input {...register('membersList')} name="memberList" value={null} hidden type="text" />
                  <input {...register('duration')} name="duration" value={duration} hidden type="text" />
                  <div className="mb-30">
                    <label htmlFor="select-start">Fecha de ida</label>
                    <select {...register('startDelivery', { required: true })} className="custom-select select-start not-pointer" id="select-start" readOnly defaultValue={startDelivery}>
                      <option value={startDelivery} defaultValue>{moment(startDelivery).format('DD/MM/YYYY')}</option>
                    </select>
                  </div>
                  <div className="mb-30">
                    <label htmlFor="select-end">Fecha de regreso</label>
                    <select {...register('endDelivery', { required: true })} className="custom-select options not-pointer" id="select-end" readOnly defaultValue={endDelivery}>
                      <option value={endDelivery} defaultValue>{moment(endDelivery).format('DD/MM/YYYY')}</option>
                    </select>
                  </div>
                  <label htmlFor="count-input">¿Cuántas Experiencias quieres adquirir?</label>
                  <Row className="input-count pb-4">
                    <Col xs={3} className="pr-0">
                      <button type="button" className="btn-form btn-right" onClick={handleLess}>-</button>
                    </Col>
                    <Col xs={6} className="px-0">
                      <input
                        {...register('count', {
                          required: true,
                          min: 1,
                          max: stockValidation,
                          onChange: e => setCount(e.target.value.replace(new RegExp(/[^\d]/,'ig'), '')),
                        })}
                        value={count}
                        id="count"
                        name="count"
                        placeholder="0"
                        className="count-input"
                        type="text" />
                    </Col>
                    <Col xs={3} className="pl-0">
                      <button type="button" className="btn-form btn-left" onClick={handlePlus}>+</button>
                    </Col>
                    <Col lg={10}>
                      {errors.count?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                      {errors.count?.type === 'min' && <small className="error-msg">* El mínimo de compra es 1</small>}
                      {errors.count?.type === 'max' && <small className="error-msg">{`* El límite del stock es: ${stockValidation}`}</small>}
                    </Col>
                  </Row>
                  <Row>
                    <div className="custom-control custom-checkbox pl-5">
                      <input
                        id="checkbox"
                        className="custom-control-input"
                        type="checkbox"
                        onChange={() => setIsCheckedYouMustKnow(!isCheckedYouMustKnow)} />
                      <label htmlFor="checkbox" className="custom-control-label">
                        <p className="ft-12 text-tangaroa font-weight-normal mb-4">
                          Acepto que he leído el apartado <HashLink to={`/${pathName}/${pathId}#experience-info`} className="link">‘Lo que debes saber’</HashLink> de esta Experiencia
                        </p>
                      </label>
                    </div>
                  </Row>
                  <button
                    type="submit" 
                    className="btn btn-primary w-100"
                    disabled={stockValidation === 0 || !isCheckedYouMustKnow}
                  >
                    Agregar al carrito
                  </button>
                </Form>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

TypeTravelMobile.propTypes = {
  details: PropTypes.object.isRequired,
  points: PropTypes.number.isRequired,
  open: PropTypes.bool,
  handleOpenExp: PropTypes.func,
  cards: PropTypes.array.isRequired,
};

export default TypeTravelMobile;
